import { AfterContentChecked, AfterViewChecked, AfterViewInit, Component, OnInit } from '@angular/core';
import { ActivitylogService } from '../services/activitylog.service';
import { ComponentheaderService } from '../services/componentheader.service';
import { param } from 'jquery';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-activitylog',
  templateUrl: './activitylog.component.html',
  styleUrls: ['./activitylog.component.css']
})
export class ActivitylogComponent implements OnInit {
  page: number = 1;
  response: any;
  logs: any;
  activityOptions = [];
  filterOptions: any;
  count: number;
  removeColumn = ["count"];
  moduleId = 0;
  constructor(private activityService: ActivitylogService, private headerInfo: ComponentheaderService, private toastr: ToastrService, private route: ActivatedRoute) {

  }

  async ngOnInit() {
    this.headerInfo.setHeaderDisplay("Activity Logs", [{ displaytext: "School", route: `/user/schoolhome` },
    { displaytext: "Activity Logs", route: `/activity/logs` }], []);

    let id = this.route.snapshot.queryParamMap.get('moduleid');
    try{
      if(id)
        this.moduleId = parseFloat(id);
    }
    catch{
      this.moduleId = 0;
    }
  }

  loadFilterData() {
    this.filterOptions = new Array();
    this.filterOptions.push(
      {
        param: 'Activity',
        dropdown: true,
        date: false,
        label: "Activity",
        dropdownOptions: this.response.activityTypes.map(item => {
          return {
            displaytext: item.toUpperCase(),
            value: item
          }
        })
      },
      {
        param: 'StartTimeStamp',
        dropdown: false,
        date: true,
        label: "From",
      },
      {
        param: 'EndTimeStamp',
        date: true,
        dropdown: false,
        label: "To",
      }
    );
  }

  setFilterData(eventData) {
    let filterParams = [];

    if (eventData.filters) {
      for (let f of eventData.filters) {
        //get dropdown values
        if (f["value"] && f["dropdown"] == true)
          filterParams.push({ value: f["value"], param: f["param"] });
        //get datetime values
        if (f["value"] && f["date"] == true)
          filterParams.push({ value: new Date(f["value"]).toISOString(), param: f["param"] });
      }
    }

    return filterParams;
  }
  async loadDataEventHandler(eventData) {

    this.headerInfo.pageLoadingStarted(this);

    let filterParams = this.setFilterData(eventData);

    await this.activityService.getActivityLogs(eventData.page, eventData.offset, this.moduleId, filterParams).toPromise().then(response => {
      this.setResult(response, eventData);
    }).catch(e => this.toastr.error(e.error));
    this.headerInfo.pageLoadingDone(this);
  }

  setResult(response, eventData) {
    this.response = response;
    this.logs = this.response.logs;
    this.logs.length > 0 ? this.count = this.response.logs[0].count : 0;
    if (this.logs.length <= 0) {
    }
    this.loadFilterData();
    if (eventData.filters)
      this.filterOptions = eventData.filters;
  }
}
